import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-warning-info',
  templateUrl: './warning-info.component.html',
  styleUrls: ['./warning-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WarningInfoComponent {
  @Input() message;
}
